import { Grid, Stack, TextField } from '@mui/material';
import Button from '@mui/material/Button';
import { useEffect } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { PerformanceCommentCategoryInputs } from '../../types/app/peformanceCommentCategory.types';
import { dictionary } from '../../utils/core/dictionary';
interface Props {
  onSubmit: SubmitHandler<PerformanceCommentCategoryInputs>;
  defaultValues?: PerformanceCommentCategoryInputs;
  onBack: any;
}

export function PerformanceCommentCategoryForm({ onSubmit, defaultValues, onBack }: Props) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<PerformanceCommentCategoryInputs>();

  useEffect(() => {
    reset({ ...defaultValues });
  }, [defaultValues, reset]);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              required
              fullWidth
              label="Name"
              {...register('name', {
                required: `PerformanceCommentCategory name ${dictionary.IS_REQUIRED}`,
              })}
              error={Boolean(errors.name)}
              helperText={errors.name?.message}
              autoFocus
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              fullWidth
              label="Ordering index"
              {...register('orderingIndex', {
                required: `Ordering index name ${dictionary.IS_REQUIRED}`,
              })}
              type="number"
              error={Boolean(errors.name)}
              helperText={errors.name?.message}
              autoFocus
            />
          </Grid>
          <Grid item>
            <Stack spacing={2} direction="row">
              <Button type="button" variant="outlined" onClick={onBack}>
                {dictionary.BACK}
              </Button>
              <Button type="submit" variant="contained" color="success">
                {dictionary.SAVE}
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
